module.exports = __webpack_public_path__ + "img/weibo.f76e782a.png";